import { useMemo } from 'react';
import KeyIndicators from 'components/KeyIndicators';
import {
	useDetailPageKeyIndicatorsDispatch,
	useDetailPageKeyIndicatorsDynamicState,
	useDetailPageKeyIndicatorsState,
} from '../DetailPageKeyIndicators/const';
import { ValueIndicator } from '../KeyIndicators/layouts/ValueIndicator';
import { MovingGradient } from '../../../../components/MovingGradient';
import FlexGrid from '../../../../components/FlexGrid';
import { getRandomBoundary } from '../../../list/listPage/ListLoadingPlaceholder/utils';

const DetailPageKeyIndicatorsPlaceholder = () => {
	const state = useDetailPageKeyIndicatorsState();
	const dynamicState = useDetailPageKeyIndicatorsDynamicState();
	const dispatch = useDetailPageKeyIndicatorsDispatch();
	const items = useMemo(() => {
		return [
			{
				id: 'test-1',
				type: 'DEFAULT',
				title: '...',
				label: '..',
				isRequired: false,
				visible: true,
			},
			{
				id: 'test-2',
				type: 'DEFAULT',
				title: '...',
				label: '..',
				isRequired: false,
				visible: true,
			},
			{
				id: 'test-3',
				type: 'DEFAULT',
				title: '...',
				label: '..',
				isRequired: false,
				visible: true,
			},
		];
	}, []);

	return (
		<KeyIndicators
			{...state}
			{...dynamicState}
			{...dispatch}
			items={items}
			render={() => {
				const titleWidth = getRandomBoundary(50, 100);

				return (
					<ValueIndicator
						value={'...'}
						title={
							<FlexGrid hrCenter>
								<MovingGradient
									height='18px'
									width={titleWidth}
								/>
							</FlexGrid>
						}
					/>
				);
			}}
			disabled
			hasIndicatorsEdit={false}
		/>
	);
};

export { DetailPageKeyIndicatorsPlaceholder };
